import { Box, Typography } from '@mui/material';
import { CheckCircle as CheckCircleIcon, Cancel as CancelIcon } from '@mui/icons-material';

interface PasswordCheckProps {
  isValid: boolean;
  label: string;
  iconSize?: number;
}

export default function PasswordCheck({ isValid, label, iconSize = 16 }: PasswordCheckProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {isValid ? (
        <CheckCircleIcon sx={{ fontSize: iconSize, color: 'success.main' }} />
      ) : (
        <CancelIcon sx={{ fontSize: iconSize, color: 'text.disabled' }} />
      )}
      <Typography variant="caption" sx={{ color: isValid ? 'success.main' : 'text.secondary' }}>
        {label}
      </Typography>
    </Box>
  );
}
